const businessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://ldlsettlementservices.com.au/#business",

  "name": "LDL Settlement Services",

  "url": "https://ldlsettlementservices.com.au/",

  "description":
    "LDL Settlement Services is a Perth-based settlement agency providing professional residential and commercial property settlement services across Western Australia.",

  "telephone": "+61 8 6156 6225",

  "email": "admin@ldlsettlementservices.com.au",

  "address": {
    "@type": "PostalAddress",
    "streetAddress": "220 Carr Place",
    "addressLocality": "Leederville",
    "addressRegion": "WA",
    "postalCode": "6007",
    "addressCountry": "AU"
  },

  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "Western Australia"
  }
};

export default businessSchema;